import { cn } from "@/lib/helpers/cn";
import { TextArea, type TextAreaProps as AriaTextAreaProps } from "react-aria-components";
import { tv, type VariantProps } from "tailwind-variants";

export type TextArea2Props = AriaTextAreaProps &
  VariantProps<typeof textAreaStyles> & {
    className?: string;
  };

export function TextArea2({ className, variant, value, ...props }: TextArea2Props) {
  const { area } = textAreaStyles({ variant });
  const isReadOnly = variant === "readOnly";
  const hasFallbackValue = isReadOnly && !value;

  return (
    <TextArea
      className={cn(area(), "atom-focus", hasFallbackValue && "tw:text-text-quaternary", className)}
      value={hasFallbackValue ? "—" : value}
      {...{ inert: isReadOnly ? "" : undefined }}
      {...props}
    />
  );
}

const textAreaStyles = tv({
  defaultVariants: { variant: "default" },
  slots: {
    area: cn(
      "input-label-placeholder",
      "tw:rounded-md tw:border tw:border-solid tw:p-2.5",
      "tw:placeholder:text-text-quinary tw:hover:placeholder:text-text-quaternary",
      "tw:disabled:cursor-not-allowed tw:disabled:bg-fill-senary tw:disabled:placeholder:text-text-quinary",
    ),
  },
  variants: {
    variant: {
      default: {
        area: "tw:border-stroke-tertiary tw:hover:border-stroke-secondary",
      },
      readOnly: {
        area: "tw:border-transparent tw:px-0 tw:pointer-events-none",
      },
    },
  },
});
